module.exports = __webpack_public_path__ + "static/img/success3.ca5e0d8b.png";